import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { currentUser, User } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { MachineService, ProductService } from '../../../../../core/plant-configuration';
import { AppState } from '../../../../../core/reducers';
import { LayoutUtilsService, QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';
import { MachineTypeService } from '../../../../../core/plant-configuration/_services/machine-type.service';
import { MachineTechTypeService } from '../../../../../core/plant-configuration/_services/machine-tech-type.service';
import { ProductTypeService } from '../../../../../core/plant-configuration/_services/product-type.service';

@Component({
	selector: 'kt-machines-list',
	templateUrl: './machines-list.component.html',
	styleUrls: []
})
export class MachinesListComponent implements OnInit, OnDestroy, AfterViewInit {


	// displayedColumns = ['select', 'active', 'login', 'group_name','login_date', 'actions'];
	filterList = [
		// {name: 'product_type_id', value: "-1", type: 'list', label: 'Tipo de producto', optionList: []},
		{name: 'machine_type_id', value: "-1", type: 'list', label: 'Tipo', optionList: []},
		{name: 'machine_tech_type_id', value: "-1", type: 'list', label: 'Tecnología', optionList: []},
		{name: 'product_id', value: "-1", type: 'list', label: 'Producto', optionList: []},
	];
	columnList = [
		// {name: 'id', displayName: 'ID', def: 'id' },
		{ name: 'name', displayName: 'Nombre', def: 'name' },
		// { name: 'product_type_name', displayName: 'Tipo de producto', def: 'product_type_name'},
		{ name: 'iiot_code', displayName: 'IIoT Code', def: 'iiot_code'},
		{ name: 'product_name', displayName: 'Producto', def: '$Products.id', transformFcn: (row)=>row.Products[0]?row.Products[0].name:''},
		{ name: 'machine_type_id', displayName: 'Tipo de máquina', def: 'machine_type_id', transformFcn: (row)=>row.MachineType?row.MachineType.name:''},
		{ name: 'machine_tech_type_id', displayName: 'Tipo de tecnología', def: 'machine_tech_type_id', transformFcn: (row)=>row.MachineTechType?row.MachineTechType.name:''},
		{ name: 'vel_max', displayName: 'Velocidad máxima', def: 'vel_max'},
	];
	actionBtns = [];
	inited = false;
	dataObs: Subject<QueryResultsModel> = new Subject<QueryResultsModel>();
	deleteObs: Subject<string> = new Subject<string>();
	subscriptions: Subscription[] = [];
	lastQuery: QueryParamsModel;
	user$: Observable<User>;
	productTypeList: any[] = [];
  machineTechTypeList: any[];
  machineTypeList: any[];
	productList: any;
	
	constructor(
		private machineService: MachineService,
		private machineTypeService: MachineTypeService,
    private machineTechTypeService: MachineTechTypeService,
    private productTypeService: ProductTypeService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private cdr: ChangeDetectorRef,
		private store: Store<AppState>,
		private productService: ProductService
	) { }

	ngOnInit() {
		this.inited = true;
		this.user$ = this.store.pipe(select(currentUser));

    this.subscriptions.push(
      of(null).pipe(
        switchMap(()=>combineLatest([
          this.machineTechTypeService.getAll(),
          this.machineTypeService.getAll(),
          this.productService.getAll(),
        ]))
      ).subscribe(([machineTechTypeList, machineTypeList, productList])=>{
        this.machineTechTypeList = machineTechTypeList;
        this.productList = productList;
        this.machineTypeList = machineTypeList;
        this.getFilter('machine_tech_type_id').optionList = this.machineTechTypeList.map(machineTechType_=>{
          return {text: machineTechType_.name, value: machineTechType_.id}
        });
        this.getFilter('product_id').optionList = this.productList.map(product=>{
          return {text: product.name, value: product.id}
        });
        this.getFilter('machine_type_id').optionList = this.machineTypeList.map(machineType=>{
          return {text: machineType.name, value: machineType.id}
        });
      })
    )
		// this.subscriptions.push(this.user$.subscribe((user)=>{
		// 	console.log("usuario: ");console.dir(user);
		// }));
	}

  getFilter(name){
    return this.filterList.find(filter=>filter.name == name);
  }

	deleteOne(userId: number) {
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.machineService.delete({ id: userId }))
			).subscribe(status => {
				this.deleteObs.next(status);
			})
		);
	}

	getPage(query: QueryParamsModel) {
		// MatSort entregaba sortField nulo. La API requiere un campo válido.
		query.sortField = query.sortField || 'id';
		this.lastQuery = query;
		console.log(`query get page: ${JSON.stringify(query)}`);
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.machineService.getPage(query))
			).subscribe(res => {
				console.log(`query result: `);console.dir(res);
				this.dataObs.next(res);
			})
		);
	}

	refresh() {
		this.getPage(this.lastQuery);
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	ngAfterViewInit() {
	}
}
